import { CanvasType } from "../../../constants/schema.js";
import { SelectType, ViewKind, VisualizationMode } from "./state.js";
import { changeVisualizationModeAction, viewOpenAction, viewSetCentersAction } from "./view.actions.js";
import { changeCanvasTypeAction } from "../settings/atom.actions.js";
//#region src/engine/modules/editor/view.generator.actions.ts
var FLOW = ViewKind.flow;
function focusCentersOf(selectedMap, tableId) {
	if (tableId && selectedMap[tableId] !== SelectType.table) return [tableId];
	return Object.entries(selectedMap).filter(([, selectType]) => selectType === SelectType.table).map(([id]) => id);
}
var focusFlowTableAction$ = (tableIds) => function* ({ editor, settings }) {
	if (!tableIds.length) return;
	if (settings.canvasType !== CanvasType.visualization) yield changeCanvasTypeAction({ value: CanvasType.visualization });
	if (editor.visualizationMode !== VisualizationMode.flow) yield changeVisualizationModeAction({ value: VisualizationMode.flow });
	yield editor.views.flow ? viewSetCentersAction({
		tableIds,
		kind: FLOW
	}) : viewOpenAction({
		kind: FLOW,
		centerIds: tableIds
	});
};
var viewActions$ = { focusFlowTableAction$ };
//#endregion
export { focusCentersOf, focusFlowTableAction$, viewActions$ };
